import { ApprovedHoursVisibleColumnName } from "./types"

export const approvedHoursDefaultColumnOrder: ApprovedHoursVisibleColumnName[] = [
  "date",
  "projectOrTask",
  "description",
  "worker",
  "started",
  "finished",
  "hours",
  "readyForCheck",
  "readyForApproval",
  "approved",
]

export const approvedHoursDefaultVisibleColumns: ApprovedHoursVisibleColumnName[] = [
  "date",
  "projectOrTask",
  "started",
  "finished",
  "hours",
  "readyForCheck",
  "readyForApproval",
  "approved",
]

export const reportHoursColumnOrder: ApprovedHoursVisibleColumnName[] = [
  "date",
  "projectOrTask",
  "description",
  "worker",
  "started",
  "finished",
  "hours",
]

export const reportHoursVisibleColumns: ApprovedHoursVisibleColumnName[] = [
  "date",
  "projectOrTask",
  "started",
  "finished",
  "hours",
]

export const getApprovedHoursColumnsForContext = (
  columns: ApprovedHoursVisibleColumnName[],
  isOrganisationContext: boolean
): ApprovedHoursVisibleColumnName[] => {
  return isOrganisationContext ? columns : columns.filter((column) => column !== "worker")
}
